import type { InferOutput } from 'valibot'
import { nullish, object } from 'valibot'
import { paragraphCollectionData, relatedDocumentsData, singleLineData } from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'
import { ctaPiece, peoplePiece } from '~/utils/crystallize/pieces'

export const becomeAuthorSchema = crystallizeDocumentSchema(
  'become-author',
  object({
    header: nullish(ctaPiece),
    contactCta: nullish(ctaPiece),
    authors: nullish(peoplePiece),
    editors: nullish(peoplePiece),
    highlightedArticle: nullish(relatedDocumentsData),
    publications: nullish(
      singleChunk(
        object({
          cta: nullish(ctaPiece),
          title: nullish(singleLineData),
          publications: nullish(paragraphCollectionData),
        }),
      ),
    ),
  }),
)

export type BecomeAuthorData = InferOutput<typeof becomeAuthorSchema>
